import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsTrendComponent } from './nps-trend.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";



@NgModule({
  declarations: [NpsTrendComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [NpsTrendComponent]
})
export class NpsTrendModule { }
